/// <reference path="../../../typings/browser.d.ts" />

namespace Application.Controllers {
    'use strict';

    export interface IGenericInfoModalScope extends ng.IScope {
        title: string;
        subtitle: string;
        content: string;
        preContent: boolean;
        modalClose: () => void;
    }

    export class GenericInfoModalController {
        public static templateUrl: string = "decorators/modals/generic-info-modal.html";
        public static ID: string = "#id-generic-info-modal";
        public static $name: string = "genericInfoModalController";
        public static $inject: string[] = ['$scope',
                                           'close',
                                           'title',
                                           'subtitle',
                                           'content',
                                           'preContent'];

        private $scope: IGenericInfoModalScope;
        private close: (parameters: ngModal.ICloseParameters) => void;

        constructor($scope: IGenericInfoModalScope,
                    close: (parameters: ngModal.ICloseParameters) => void,
                    title: string,
                    subtitle: string,
                    content: string,
                    preContent: boolean) {
            this.$scope = $scope;
            this.$scope.title = title;
            this.$scope.subtitle = subtitle;
            this.$scope.content = content;
            this.$scope.preContent = preContent;
            this.close = close;

            this.$scope.modalClose = (): void => {
                this.close(undefined);
            };
        }
    }
}
